import { StudentLayout } from 'src/components/Layout/student/StudentLayout';
import { FC, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Loader from '../../../components/Loader';
import { useGetGroupSearchDataQuery, useGetGroupsQuery } from 'src/api';
import { GroupCard } from './components';
import { type Filters, GroupActionTab } from './components/GroupActionTab';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { AuthorizedUserProps } from 'src/routes/components/PrivateRoute';

const filtersToQuery = (filters: Filters): string => {
    let query = '';

    if (filters.search) {
        query += `search=${filters.search}&`;
    }
    if (filters.sort) {
        query += `sort=${filters.sort}&`;
    }
    if (filters.statuses && filters.statuses.length) {
        query += `statuses=${filters.statuses.join(',')}&`;
    }
    if (filters.years && filters.years.length) {
        query += `years=${filters.years.join(',')}&`;
    }

    return query;
};

export const GroupsPage: FC<AuthorizedUserProps> = (
    props: AuthorizedUserProps
) => {
    const [filters, setFilters] = useState<Filters>({});

    const { data, isLoading, isFetching } = useGetGroupsQuery({
        search: filtersToQuery(filters),
        params: { branchId: props.currentBranchId },
    });

    const { data: filterData, isLoading: isFilterDataLoading } =
        useGetGroupSearchDataQuery();

    return (
        <StudentLayout auth={props}>
            <Helmet title={'Группы'} />
            <main className="grid ml-0 mr-0">
                <GroupActionTab
                    isFetching={isFetching}
                    branchId={props.currentBranchId}
                    filterData={
                        filterData ?? {
                            sorting: [],
                            statuses: [],
                            years: [],
                        }
                    }
                    filters={filters}
                    setFilters={setFilters}
                />
                {isLoading || isFilterDataLoading ? (
                    <Loader />
                ) : data?.length ? (
                    data?.map(group => (
                        <GroupCard
                            branch={props.currentBranchId}
                            key={group.id}
                            {...group}
                        />
                    ))
                ) : (
                    'Ничего не найдено'
                )}
            </main>
            <ConfirmDialog />
        </StudentLayout>
    );
};
